/**
 * Запросы к `GET /api/admin/data-health` — заполненность показателей паспорта.
 *
 * Требует Bearer + роль `DIGPASSADMIN_INGTR`. Регион не передаётся параметром:
 * backend берёт его из запроса (env развёртывания или клейм JWT).
 */
import { api } from './api';

/** Уровень КАТО → число единиц. Ключ `unknown` — КАТО без уровня. */
export type LevelCounts = Record<string, number>;

export interface DataHealthIndicator {
  key: string;
  section: string;
  name_ru: string;
  name_kz: string;

  /** Стабильный код источника: `STATBASE`, `BNS`, `MANUAL`, … */
  source: string;
  source_ru: string;
  source_kz: string;

  table: string;
  columns: string[];

  scope: string;
  scope_ru: string;
  scope_kz: string;
  /** `KATO` | `KATO_TEXT` | `ROWS` — как измерен охват. */
  measure: string;

  /** Сколько КАТО обязаны иметь показатель. `null` — охват неизмерим. */
  expected: number | null;
  filled: number;
  percent: number | null;
  /** Всего строк таблицы в регионе. */
  rows: number;
  by_level: LevelCounts;

  note_ru: string | null;
  note_kz: string | null;
}

export interface DataHealthSection {
  key: string;
  name_ru: string;
  name_kz: string;
  expected: number;
  filled: number;
  percent: number | null;
  indicators: DataHealthIndicator[];
}

export interface DataHealthReport {
  region_id: number;
  region_code: string;
  region_name_ru: string;
  region_name_kz: string;
  year: number | null;
  /** Территория фильтра; `null` — отчёт по всему региону. */
  kato: number | null;
  kato_name_ru: string | null;
  kato_name_kz: string | null;
  generated_at: string;
  kato_totals: LevelCounts;
  expected: number;
  filled: number;
  percent: number | null;
  sections: DataHealthSection[];
}

export interface DataHealthQuery {
  year?: number | null;
  /** Код КАТО: отчёт сузится до этой территории и её потомков. */
  kato?: number | null;
}

export const getDataHealth = async (
  query: DataHealthQuery = {},
): Promise<DataHealthReport> => {
  const params: Record<string, number> = {};
  if (query.year != null) params.year = query.year;
  if (query.kato != null) params.kato = query.kato;

  const response = await api.get<DataHealthReport>('/admin/data-health', {
    // Пустой объект не шлём: axios добавил бы `?`, а тесты и логи станут шумнее.
    params: Object.keys(params).length === 0 ? undefined : params,
  });
  return response.data;
};
